export default function getActions() {
  return {
    view: {
      id: 1,
      name: "View",
    },
    create: {
      id: 2,
      name: "Create",
    },
    update: {
      id: 3,
      name: "Update",
    },
    delete: {
      id: 4,
      name: "Delete",
    },
    void: {
      id: 5,
      name: "Void",
    },
    allow: {
      id: 6,
      name: "Allow",
    },
    activate: {
      id: 7,
      name: "Activate",
    },
  };
}
